import { useState, useCallback } from 'react';
import { MetadataRow } from '../types/suitableSubstituteTypes';

export const useRowDragDrop = (metadataRows: MetadataRow[]) => {
  const [draggedRowIndex, setDraggedRowIndex] = useState<number | undefined>();

  const handleDragStart = useCallback(
    (event: React.DragEvent, index: number) => {
      if (!metadataRows[index].isDraggable) {
        event.preventDefault();
        return;
      }
      setDraggedRowIndex(index);
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/html', event.currentTarget.outerHTML);
    },
    [metadataRows]
  );

  const handleDragOver = useCallback((event: React.DragEvent) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
  }, []);

  const handleDrop = useCallback(
    (event: React.DragEvent, dropIndex: number, onRowsReorder: (newRows: MetadataRow[]) => void) => {
      event.preventDefault();

      if (draggedRowIndex === undefined || draggedRowIndex === dropIndex) {
        setDraggedRowIndex(undefined);
        return;
      }

      if (!metadataRows[dropIndex].isDraggable) {
        setDraggedRowIndex(undefined);
        return;
      }

      const newRows = [...metadataRows];
      const draggedRow = newRows[draggedRowIndex];
      newRows.splice(draggedRowIndex, 1);
      newRows.splice(dropIndex, 0, draggedRow);

      onRowsReorder(newRows);
      setDraggedRowIndex(undefined);
    },
    [draggedRowIndex, metadataRows]
  );

  const handleDragEnd = useCallback(() => {
    setDraggedRowIndex(undefined);
  }, []);

  return {
    draggedRowIndex,
    handleDragStart,
    handleDragOver,
    handleDrop,
    handleDragEnd,
  };
};
